import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const SubHeading = styled.span`
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '14px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#202124' : isDemi && '#202124'};
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '14px' : '14px')};
        margin-top: 6px;
    `}
`;

export const Heading = styled.span`
    text-align: right;
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '12px' : '12px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#140F4B'};
    ${media.mobileDevice`
    text-align: left;
        font-size: ${({ isDemi }) => (isDemi ? '12px' : '12px')};
        color: ${({ isRegular, isDemi }) =>
            isRegular ? '#140F4B' : isDemi && '#140F4B'};
    `}
`;

export const DesktopSearch = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    align-items: center;
    ${media.mobileDevice`
    display: none;
    `}
`;

export const MobileSearch = styled.div`
    display: none;
    ${media.mobileDevice`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    `}
`;

export const ClearButton = styled.div`
    font-family: 'AvenirNextWorld Demi';
    cursor: pointer;
    color: #1010eb;
    text-align: center;
    font-size: 13px;
    width: 90px;
    height: 33px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    border: 1px solid var(--unnamed-color-ebebeb);
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    padding-top: 6px;
    ${media.mobileDevice`
    min-width: 73px;
    width: max-content;
    height: 34px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 0px 2px #00000029;
border: 1px solid #EBEBEB;
border-radius: 6px;
opacity: 1;
    `}
`;

export const StyledSortIcon = styled.div`
    width: 18px;
    height: 16px;
    margin-top: 11.95px;
    ${media.mobileDevice` 
        margin-right: -15px;
    `}
`;

export const SortContainer = styled.div`
    display: none;
    ${media.mobileDevice`
    display: block;
    width: 221px;
height: 40px;
background: #FFFFFF 0% 0% no-repeat padding-box;
border: 2px solid #EBEDED;
border-radius: 6px;
opacity: 1;
font-family: 'AvenirNextWorld Regular';
color: #202124;
text-align: left;
font-size: 14px;
padding-top: 8px;
    `}
`;
